(ns web3.components.classes
  (:require [goog.dom.classes :as classes]
            [web3.view :as v]
            [web3.utils :as utils]))

(v/defview set-classes
  "Utility component for setting classes on document body.

  Pass in a function which returns a map of classnames to values.
  Classes are added or removed according to truthiness of associated value.

  Function is called in render method to trigger reactivity."
  {:component-will-update
   (fn [^js this argv]
     (.setClasses this argv))
   :component-will-mount
   (fn [^js this]
     (.setClasses this (:argv this)))
   :setClasses
   (fn [[_ element classes :as argv]]
     (doseq [[key val] (utils/eval-if-fn classes)]
       (if val
         (classes/add element (name key))
         (classes/remove element (name key)))))}
  [element classes]
  (utils/eval-if-fn classes)
  nil)